<template>
  <td :class="[`cell-value-${col}`]">
    <small>{{ getString(entry[col]) }}</small>
  </td>
</template>

<script>
export default {
  props: {
    entry: Object,
    col: String,
    editName: String,
    flags: Array,
  },
  methods: {
    getString(input) {
      const inputdate = new Date(input);
      return inputdate.toLocaleString('cs-CZ');
    },
  },
};
</script>

<style lang="scss" scoped>
small {
  font-size: 0.7em;
  white-space: nowrap;
}
</style>
